// for errors that we want to detect on the client
var socialLoginEmailExistsError = new Error('user with this email already exists');
module.exports = {
  socialLoginEmailExistsError: socialLoginEmailExistsError
};